const EmptyReview = () => {
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M79.7 131.6C107.7 131.6 130.4 108.9 130.4 80.8C130.4 52.7 107.7 30 79.7 30C51.7 30 29 52.7 29 80.8C29 108.9 51.7 131.6 79.7 131.6Z"
        fill="#F5F5F5"
      />
      <path
        d="M136.2 59.9C138.464 59.9 140.3 58.0643 140.3 55.7999C140.3 53.5356 138.464 51.7 136.2 51.7C133.936 51.7 132.1 53.5356 132.1 55.7999C132.1 58.0643 133.936 59.9 136.2 59.9Z"
        fill="#F5F5F5"
      />
      <path
        d="M142.2 43.8C143.746 43.8 145 42.5463 145 41C145 39.4536 143.746 38.2 142.2 38.2C140.654 38.2 139.4 39.4536 139.4 41C139.4 42.5463 140.654 43.8 142.2 43.8Z"
        fill="#F5F5F5"
      />
      <path
        d={`M25.5002 62.7999C27.0465 62.7999 28.3002 61.5463 28.3002 60C28.3002 58.4536 27.0465 57.2 25.5002 57.2C23.9538 57.2 
        22.7002 58.4536 22.7002 60C22.7002 61.5463 23.9538 62.7999 25.5002 62.7999Z`}
        fill="#F5F5F5"
      />
      <path
        d="M30.7 123.7C33.5719 123.7 35.9 121.372 35.9 118.5C35.9 115.628 33.5719 113.3 30.7 113.3C27.8281 113.3 25.5 115.628 25.5 118.5C25.5 121.372 27.8281 123.7 30.7 123.7Z"
        fill="#F5F5F5"
      />
      <g filter="url(#filter0_d_5276_33547)">
        <g filter="url(#filter1_d_5276_33547)">
          <path
            d="M126.7 60.5H39.9996C38.0996 60.5 36.5996 59 36.5996 57.1V37.6C36.5996 35.7 38.0996 34.2 39.9996 34.2H126.6C128.5 34.2 130 35.7 130 37.6V57.1C130.1 59 128.5 60.5 126.7 60.5Z"
            fill="white"
          />
        </g>
      </g>
      <path
        d={`M57.5996 47.3C57.5996 49.5 56.5996 51.5 55.0996 52.9C53.7996 54.1 51.9996 54.8 50.0996 54.8C48.1996 54.8 46.3996 54.1 45.0996
         52.9C43.4996 51.5 42.5996 49.5 42.5996 47.3C42.5996 43.2 45.9996 39.8 50.0996 39.8C54.1996 39.8 57.5996 43.2 57.5996 47.3Z`}
        fill="#F5F5F5"
      />
      <path
        d={`M55.0996 52.9C53.7996 54.1 51.9996 54.8 50.0996 54.8C48.1996 54.8 46.3996 54.1 45.0996 52.9C45.6996 52.7 46.3996 52.4 47.2996 
        52C47.4996 51.9 47.6996 51.7 47.7996 51.5C47.8996 51.4 47.8996 51.2 47.8996 51.1V49.2L47.7996 49.1C47.5996 48.9 47.4996 48.6 47.4996 
        48.3L47.2996 48.2C46.7996 48.3 46.8996 47.8 46.6996 46.8C46.6996 46.4 46.6996 46.3 46.8996 46.2L47.0996 46C46.1996 43.9 46.5996 42.6 
        47.5996 42.1C47.2996 41.4 47.2996 41.2 47.2996 41.2C47.2996 41.2 49.2996 41.5 49.8996 41.4C50.7996 41.2 52.0996 41.4 52.5996 42.6C53.3996 
        42.9 53.6996 43.4 53.7996 44C53.8996 44.9 53.3996 45.9 53.2996 46.2C53.3996 46.3 53.4996 46.4 53.3996 46.7C53.2996 47.6 53.2996 48.2 52.7996 
        48.1L52.3996 49C52.3996 49.1 52.3996 49.1 52.3996 49.2C52.3996 49.3 52.3996 49.6 52.3996 51.2C52.3996 51.4 52.4996 51.6 52.4996 51.7C52.5996
         51.9 52.7996 52 52.8996 52.1C53.7996 52.4 54.4996 52.7 55.0996 52.9Z`}
        fill="white"
      />
      <path
        d={`M53.3265 46.3C53.3265 46.0918 53.2225 45.7796 53.1184 45.5714V45.4673C52.702 44.6347 51.8694 44.3224 51.0367 44.3224C48.9551 
        44.2183 48.7469 44.6347 48.0184 44.0102C48.2265 44.3224 48.2265 44.8428 47.9143 45.4673C47.7061 45.8836 47.2898 46.0918 46.8735 
        46.1959C45.9367 44.0102 46.353 42.6571 47.3939 42.1367C47.0816 41.4081 47.0816 41.2 47.0816 41.2C47.0816 41.2 49.1633 41.5122 49.7878 
        41.4081C50.7245 41.2 52.0776 41.4081 52.598 42.6571C53.4306 42.9693 53.7429 43.4898 53.8469 44.1142C53.951 44.8428 53.4306 45.8836 53.3265 46.3Z`}
        fill="#595959"
      />
      <path
        d={`M52.4998 51.6999V52.0999H47.7998V51.5999C47.8998 51.4999 47.8998 51.2999 47.8998 51.1999V49.2999L47.7998 49.1999V49.0999C47.8998 
        49.2999 47.9998 49.3999 48.1998 49.5999L49.6998 50.5999C49.9998 50.8999 50.4998 50.8999 50.8998 50.5999L52.2998 49.3999L52.3998 
        49.2999C52.3998 49.3999 52.3998 49.6999 52.3998 51.2999C52.2998 51.3999 52.3998 51.4999 52.4998 51.6999Z`}
        fill="white"
      />
      <path
        d={`M82.2002 45.1H63.0002C62.5002 45.1 62.2002 44.7 62.2002 44.3V41.8C62.2002 41.3 62.6002 41 63.0002
         41H82.2002C82.7002 41 83.0002 41.4 83.0002 41.8V44.3C83.0002 44.8 82.7002 45.1 82.2002 45.1Z`}
        fill="#BFBFBF"
      />
      <path
        d="M105 53.6H63.0002C62.5002 53.6 62.2002 53.2 62.2002 52.8V50.3C62.2002 49.8 62.6002 49.5 63.0002 49.5H105C105.5 49.5 105.8 49.9 105.8 50.3V52.8C105.8 53.3 105.4 53.6 105 53.6Z"
        fill="#BFBFBF"
      />
      <g filter="url(#filter2_d_5276_33547)">
        <g filter="url(#filter3_d_5276_33547)">
          <path
            d={`M126.7 126.1H39.9996C38.0996 126.1 36.5996 124.6 36.5996 122.7V103.2C36.5996 101.3 38.0996 99.8 39.9996
             99.8H126.6C128.5 99.8 130 101.3 130 103.2V122.7C130.1 124.6 128.5 126.1 126.7 126.1Z`}
            fill="white"
          />
        </g>
      </g>
      <path
        d={`M57.5996 112.9C57.5996 115.1 56.5996 117.1 55.0996 118.5C53.7996 119.7 51.9996 120.4 50.0996 120.4C48.1996 120.4 46.3996 119.7 45.0996 118.5C43.4996 117.1 42.5996 115.1 
        42.5996 112.9C42.5996 108.8 45.9996 105.4 50.0996 105.4C54.1996 105.4 57.5996 108.8 57.5996 112.9Z`}
        fill="#F5F5F5"
      />
      <path
        d={`M55.0996 118.5C53.7996 119.7 51.9996 120.4 50.0996 120.4C48.1996 120.4 46.3996 119.7 45.0996 118.5C45.6996 118.3 
        46.3996 118 47.2996 117.6C47.4996 117.5 47.6996 117.3 47.7996 117.1C47.8996 117 47.8996 116.8 47.8996 116.7V114.8L47.7996 
        114.7C47.5996 114.5 47.4996 114.2 47.4996 113.9L47.2996 113.8C46.7996 113.9 46.8996 113.4 46.6996 112.4C46.6996 112 46.6996
         111.9 46.8996 111.8L47.0996 111.6C46.1996 109.5 46.5996 108.2 47.5996 107.7C47.2996 107 47.2996 106.8 47.2996 106.8C47.2996 
         106.8 49.2996 107.1 49.8996 107C50.7996 106.8 52.0996 107 52.5996 108.2C53.3996 108.5 53.6996 109 53.7996 109.6C53.8996 110.5
          53.3996 111.5 53.2996 111.8C53.3996 111.9 53.4996 112 53.3996 112.3C53.2996 113.2 53.2996 113.8 52.7996 113.7L52.3996 114.5C52.3996
           114.6 52.3996 114.6 52.3996 114.7C52.3996 114.8 52.3996 115.1 52.3996 116.7C52.3996 116.9 52.4996 
        117.1 52.4996 117.2C52.5996 117.4 52.7996 117.5 52.8996 117.6C53.7996 118.1 54.4996 118.3 55.0996 118.5Z`}
        fill="white"
      />
      <path
        d={`M53.3265 111.9C53.3265 111.692 53.2225 111.38 53.1184 111.171V111.067C52.702 110.235 51.8694 109.923 51.0367 109.923C48.9551 
        109.818 48.7469 110.235 48.0184 109.61C48.2265 109.923 48.2265 110.443 47.9143 111.067C47.7061 111.484 47.2898 111.692 46.8735 
        111.796C45.9367 109.61 46.353 108.257 47.3939 107.737C47.0816 107.008 47.0816 106.8 47.0816 106.8C47.0816 106.8 49.1633 107.112 
        49.7878 107.008C50.7245 106.8 52.0776 107.008 52.598 108.257C53.4306 108.569 53.7429 109.09 53.8469 109.714C53.951 110.547 53.4306 
        111.484 53.3265 111.9Z`}
        fill="#595959"
      />
      <path
        d={`M52.4998 117.3V117.7H47.7998V117.2C47.8998 117.1 47.8998 116.9 47.8998 116.8V114.9L47.7998 114.8V114.7C47.8998 
        114.9 47.9998 115 48.1998 115.2L49.6998 116.2C49.9998 116.5 50.4998 116.5 50.8998 116.2L52.2998 115L52.3998 114.9C52.3998 
        115 52.3998 115.3 52.3998 116.9C52.2998 117 52.3998 117.2 52.4998 117.3Z`}
        fill="white"
      />
      <path
        d={`M82.2002 110.8H63.0002C62.5002 110.8 62.2002 110.4 62.2002 110V107.5C62.2002 107 62.6002 106.7 63.0002 106.7H82.2002C82.7002 106.7
         83.0002 107.1 83.0002 107.5V110C83.0002 110.4 82.7002 110.8 82.2002 110.8Z`}
        fill="#BFBFBF"
      />
      <path
        d="M105 119.3H63.0002C62.5002 119.3 62.2002 118.9 62.2002 118.5V116C62.2002 115.5 62.6002 115.2 63.0002 115.2H105C105.5 115.2 105.8 115.6 105.8 116V118.5C105.8 118.9 105.4 119.3 105 119.3Z"
        fill="#BFBFBF"
      />
      <g filter="url(#filter4_d_5276_33547)">
        <g filter="url(#filter5_d_5276_33547)">
          <path
            d="M112 93.3H25.4C23.5 93.3 22 91.8 22 89.9V70.4C22 68.5 23.5 67 25.4 67H112C113.9 67 115.4 68.5 115.4 70.4V89.9C115.5 91.8 113.9 93.3 112 93.3Z"
            fill="white"
          />
        </g>
      </g>
      <path
        d={`M67.5996 77.9001H48.3996C47.8996 77.9001 47.5996 77.5 47.5996 77.1V74.6C47.5996 74.1 47.9996 73.8 48.3996 73.8H67.5996C68.0996 
        73.8 68.3996 74.2 68.3996 74.6V77.1C68.3996 77.6 68.0996 77.9001 67.5996 77.9001Z`}
        fill="#BFBFBF"
      />
      <path
        d={`M90.3996 86.5001H48.3996C47.8996 86.5001 47.5996 86.1001 47.5996 85.7001V83.2001C47.5996 82.7001 47.9996 82.4001 48.3996 
        82.4001H90.2996C90.7996
         82.4001 91.0996 82.8001 91.0996 83.2001V85.7001C91.1996 86.1001 90.7996 86.5001 90.3996 86.5001Z`}
        fill="#BFBFBF"
      />
      <path
        d={`M43.1 80.1001C43.1 82.2001 42.2 84.1001 40.8 85.5001C40.7 85.6001 40.7 85.6001 40.6 85.7001C39.3 86.9001 37.5 87.6001 35.6 87.6001C33.7 
        87.6001 32 86.9001 30.7 85.8001C30.7 85.8001 30.7 85.8001 30.6 85.8001C29 84.4001 28 82.4001 28 80.1001C28 76.0001 31.4 72.6001 35.5 72.6001C39.7 72.6001 43.1 76.0001 43.1 80.1001Z`}
        fill="#F5F5F5"
      />
      <path
        d={`M40.7707 85.6525C40.4665 84.9426 39.9594 84.3341 39.1482 83.9285C38.7425 83.7257 38.4383 83.6243 37.9312 83.6243H37.627C36.9171 83.6243
         36.8157 83.5228 36.8157 83.5228V82.3059C37.627 81.6975 38.2355 80.8862 38.4383 79.9735C38.9453 79.8721 39.2496 79.4665 39.1482 78.9594C39.1482 
         78.7566 38.9453 78.5538 38.9453 78.3509C38.9453 78.2495 38.9453 78.1481 38.9453 78.0467C38.9453 77.9453 38.9453 77.9453 38.9453 77.8439C38.9453
          77.7425 38.9453 77.7425 38.9453 77.6411C38.9453 77.2354 38.8439 76.9312 38.5397 76.5256C37.9312 75.4101 36.7143 74.7002 35.396 74.7002C35.0918 
          74.7002 34.8889 74.7002 34.5847 74.8016C34.0777 74.903 33.672 75.1058 33.2664 75.4101C33.165 75.5115 33.165 75.5115 33.0636 75.6129C33.0636 
          75.6129 33.0636 75.6129 32.9622 75.7143C32.5565 76.1199 32.2523 76.627 32.0495 77.134C31.8466 77.6411 31.8466 78.2495 31.8466 78.858C31.8466 
          78.858 31.8466 78.858 31.8466 78.9594C31.8466 79.0608 31.8466 79.0608 31.8466 79.1622C31.8466 79.1622 31.8466 79.2636 31.7452 79.2636C31.9481
           79.0608 31.8466 79.365 31.9481 79.5679C32.1509 80.0749 32.4551 79.9735 32.8607 80.2777C32.8607 80.2777 32.8607 80.2777 32.7593 80.2777L32.3537
            80.3791C30.1227 81.089 29.9199 83.4214 32.1509 83.9285C31.9481 84.0299 31.8466 84.1313 31.7452 84.1313C31.1368 84.6384 30.7311 85.2468 30.5283
             85.8553C31.8466 86.9708 33.5706 87.6806 35.4974 87.6806C37.4242 87.6806 39.2496 86.9708 40.5679 85.7539C40.6693 85.8553 40.7707 85.7539 40.7707
              85.6525C40.8721 85.6525 40.8721 85.6525 40.7707 85.6525ZM34.4833 83.2186C34.3819 83.1172 34.2805 83.0158 34.2805 83.0158C34.1791 82.9144 
              34.0777 82.9144 33.9763 82.813C33.9763 82.813 33.8748 82.813 33.8748 82.7116C33.5706 82.5087 33.2664 82.3059 33.165 82.0017C33.165 81.9003
               33.2664 81.6975 33.4692 81.4947C33.5706 81.5961 33.672 81.6975 33.7734 81.9003C33.8748 82.0017 33.9763 82.1031 34.0777 82.2045C34.1791 
               82.2045 34.2805 82.3059 34.2805 82.4073C34.2805 82.4073 34.2805 82.4073 34.3819 82.4073C34.3819 82.4073 34.3819 82.4073 34.4833 
               82.4073V83.2186Z`}
        fill="white"
      />
      <path
        d={`M37.7504 83.5664C37.6504 83.9664 37.4504 84.2664 37.4504 84.2664L33.6504 83.6664L33.8504 82.6664C33.8504 82.6664 33.9504 82.6664 
        33.9504 82.7664C34.0504 82.8664 34.1504 82.8664 34.2504 82.9664C34.3504 82.9664 34.3504 83.0664 34.4504 83.1664V82.4664C34.4504 82.4664 
        34.4504 82.4664 34.3504 82.4664C34.9504 82.7664 35.7504 82.9664 36.8504 82.2664V83.4664C36.9504 83.4664 37.0504 83.5664 37.7504 83.5664Z`}
        fill="white"
      />
      <path
        d={`M36.9595 77.9886C37.6729 77.9886 38.3863 77.8866 38.9978 77.6828C38.9978 77.6828 38.9978 77.5809 39.0997 77.479C38.9978 77.1732 
        38.8958 76.7656 38.692 76.3579C38.0805 75.2368 36.8575 74.5234 35.5326 74.5234C35.2269 74.5234 34.9336 74.5452 34.5247 74.6472C33.9805 
        74.8135 33.7278 74.9597 33.5989 75.0378C33.5989 75.0378 33.301 75.2381 33.0867 75.4407C32.8724 75.6432 32.3733 76.3579 32.1694 76.8675C31.9656 
        77.479 31.8012 77.9987 31.9031 78.6102C32.005 78.6102 32.1694 78.4981 32.2714 78.4981C33.0867 78.0905 33.6982 77.5809 34.0039 76.7656C34.8192 
        77.479 35.8384 77.8866 36.9595 77.9886Z`}
        fill="#595959"
      />
      <path
        d={`M34.9001 85.3C34.6001 85.7 34.1001 85.7001 33.6001 85.7001C34.1001 85.2001 33.8001 83.7001 32.2001 83.9001C29.9001 83.5001 30.2001
         81.1001 32.4001 80.4001L32.8001 80.3C32.8001 80.3 32.8001 80.3001 32.9001 80.4001C33.1001 80.9001 33.3001 81.2 33.6001 81.6C32.7001 
         82.4 34.0001 82.6001 34.6001 83.2001C35.0001 83.4001 35.4001 84.7 34.9001 85.3Z`}
        fill="#595959"
      />
      <defs>
        <filter
          id="filter0_d_5276_33547"
          x="27.5996"
          y="30.2"
          width="111.404"
          height="44.3"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="5" />
          <feGaussianBlur stdDeviation="4.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5276_33547"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5276_33547"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_5276_33547"
          x="24.5996"
          y="25.2"
          width="117.404"
          height="50.3"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5276_33547"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5276_33547"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_5276_33547"
          x="27.5996"
          y="95.8"
          width="111.404"
          height="44.3"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="5" />
          <feGaussianBlur stdDeviation="4.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5276_33547"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5276_33547"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_5276_33547"
          x="24.5996"
          y="90.8"
          width="117.404"
          height="50.3"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5276_33547"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5276_33547"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_5276_33547"
          x="13"
          y="63"
          width="111.404"
          height="44.3"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="5" />
          <feGaussianBlur stdDeviation="4.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5276_33547"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5276_33547"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_5276_33547"
          x="10"
          y="58"
          width="117.404"
          height="50.3"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5276_33547"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5276_33547"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default EmptyReview;
